//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Libraries
import moment from 'moment'
moment.locale('pt-BR')

export default {
  nuxtI18n: {
    paths: {
      br: '/noticias/:category/:post',
      en: '/news/:category/:post',
      es: '/noticias/:category/:post'
    }
  },

  async asyncData({ $api, params }) {
    try {
      // Get news post
      const { post } = params
      const { data } = await $api.news.show(post)
      const { news, related_news } = data

      // Get news categories
      const categories = await $api.news.categories().then((response) => {
        return response.map((category) => {
          return {
            label: category.title,
            value: category.slug
          }
        })
      })

      return {
        news,
        related_news,
        categories
      }
    } catch (err) {
      $api.instance.handleResponseError(err)
    }
  },

  data() {
    return {
      filter: {
        search: ''
      },
      news: {},
      categories: [],
      related_news: []
    }
  },

  head() {
    const { title, seo, main_image } = this.news

    return this.$helpers.seoBuilder(this, {
      staticTitle: seo ? seo.title : title || this.$t('title'),
      staticDescription: seo ? seo.description : null,
      ogImage: main_image ? main_image.url : null,
      ogImageWidth: main_image ? 771 : null,
      ogImageHeight: main_image ? 428 : null
    })
  },

  computed: {
    breadcrumbs() {
      const breadcrumbs = [
        {
          name: this.$t('home'),
          path: '/'
        },
        {
          name: this.$t('title'),
          path: '/noticias'
        }
      ]

      if (this.news.category) {
        breadcrumbs.push({
          name: this.news.category.title,
          path: `/noticias/${this.news.category.slug}`
        })
      }

      breadcrumbs.push({
        name: this.news.title,
        path: this.$route.fullPath
      })

      return breadcrumbs
    }
  },

  methods: {
    moment,

    onSearch() {
      const { search } = this.filter

      if (search) {
        const query = {}

        query[this.$t('search')] = search

        this.$router.push({
          path: this.localePath('/noticias'),
          query
        })
      }
    }
  }
}
